import { put, takeEvery, select } from 'redux-saga/effects'
import { Game, Api, Auth } from '../../Core'

import * as selectors from './events.selectors'

import * as actions from './events.actions'
import * as miningActions from '../Mining/mining.actions'

import EventsViewer from './EventsViewer'

export function* loadComponents() {
  const components = {
    EventsViewer,
  }
  yield put(Game.actions.registerComponents(components))
}

export function* chooseEventOption(action) {
  const newEvent = action.data

  yield executeEvent(newEvent)
}

export function* loadEvent() {
  const event = yield select(selectors.getCurrentEvent)

  if (event) {
    event.options ? yield setExecutedEvent(event) : yield executeEvent(event)
  }
}

export function* executeEvent(event) {
  const userInfo = yield select(Auth.selectors.getUserInfo)
  const payload = {
    event,
    groupId: userInfo.licenseData.groupId,
  }
  try {
    const returnedEvent = yield Api.post(
      `/events/executeEvent?playerId=${userInfo.licenseId}`,
      {},
      payload
    )
    yield setExecutedEvent(returnedEvent)
  } catch (e) {
    console.log(e)
  }
}

export function* setExecutedEvent(event) {
  yield put(actions.setExecutedEvent(event))
  yield put(miningActions.changeMiningScreen('events_viewer'))
}

export function* init() {
  yield loadComponents()
}

export function* sagas() {
  yield init()
  yield takeEvery(actions.LOAD_EVENT, loadEvent)
  yield takeEvery(actions.CHOOSE_EVENT_OPTION, chooseEventOption)
}
